export default __webpack_public_path__ + "static/media/g-gtav.c5f1b781.jpg";